"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Apply_1 = require("fp-ts/lib/Apply");
var internal = function (F) {
    var sequenceTF = Apply_1.sequenceT(F);
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var fas = args.slice(0, args.length - 1);
        var project = args[args.length - 1];
        var sequenced = sequenceTF.apply(null, fas);
        return F.map(sequenced, function (as) { return project.apply(void 0, as); });
    };
};
/**
 * Sequences multiple {@link ProductLeft}s of kind `*->*->*`
 * applicatively accumulating their values and then applying `project` function to those values
 * and wrapping its result in the same {@link ProductLeft} with a `product` (`&`) of types of _left_ side
 */
function productMapLeft(F) {
    return internal(F);
}
exports.productMapLeft = productMapLeft;
/**
 * Sequences multiple {@link CoproductLeft}s of kind `*->*->*`
 * applicatively accumulating their values and then applying `project` function to those values
 * and wrapping its result in the same {@link CoproductLeft} with a `coproduct` (`|`) of types of _left_ side
 */
function coproductMapLeft(F) {
    return internal(F);
}
exports.coproductMapLeft = coproductMapLeft;
//# sourceMappingURL=product-left-coproduct-left.utils.js.map